import { connect } from 'react-redux'
import { ForgotPassword } from './ForgotPassword'
import { startResetPassword } from './store/ForgotPasswordActions'
import { getForgotPasswordSubmitting } from './store/ForgotPasswordSelectors'
import { IGlobalState } from '../../Root/store/appReducer'

const mapStateToProps = (state: IGlobalState) => ({
  submitting: getForgotPasswordSubmitting(state),
})

const mapDispatchToProps = {
  startResetPassword,
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
